const countriesEnum = {
  AF: 'AF',
  AL: 'AL',
  DE: 'DE',
  AD: 'AD',
  AO: 'AO',
  AI: 'AI',
  AQ: 'AQ',
  AG: 'AG',
  SA: 'SA',
  DZ: 'DZ',
  AR: 'AR',
  AM: 'AM',
  AW: 'AW',
  AU: 'AU',
  AT: 'AT',
  AZ: 'AZ',
  BS: 'BS',
  BH: 'BH',
  BD: 'BD',
  BB: 'BB',
  BE: 'BE',
  BZ: 'BZ',
  BJ: 'BJ',
  BM: 'BM',
  BY: 'BY',
  BO: 'BO',
  BQ: 'BQ',
  BA: 'BA',
  BW: 'BW',
  BR: 'BR',
  BN: 'BN',
  BG: 'BG',
  BF: 'BF',
  BI: 'BI',
  BT: 'BT',
  CV: 'CV',
  KH: 'KH',
  CM: 'CM',
  CA: 'CA',
  CL: 'CL',
  CN: 'CN',
  CY: 'CY',
  CO: 'CO',
  CI: 'CI',
  CR: 'CR',
  HR: 'HR',
  CU: 'CU',
  CW: 'CW',
  DK: 'DK',
  DJ: 'DJ',
  DM: 'DM',
  EC: 'EC',
  EG: 'EG',
  SV: 'SV',
  ER: 'ER',
  SK: 'SK',
  SI: 'SI',
  ES: 'ES',
  US: 'US',
  EE: 'EE',
  ET: 'ET',
  FJ: 'FJ',
  PH: 'PH',
  FI: 'FI',
  FR: 'FR',
  GA: 'GA',
  GM: 'GM',
  GS: 'GS',
  GH: 'GH',
  GI: 'GI',
  GD: 'GD',
  GR: 'GR',
  GL: 'GL',
  GP: 'GP',
  GU: 'GU',
  GT: 'GT',
  GY: 'GY',
  GF: 'GF',
  GG: 'GG',
  GN: 'GN',
  GW: 'GW',
  HT: 'HT',
  HN: 'HN',
  HK: 'HK',
  HU: 'HU',
  IN: 'IN',
  ID: 'ID',
  IQ: 'IQ',
  IR: 'IR',
  IE: 'IE',
  BV: 'BV',
  IM: 'IM',
  CX: 'CX',
  HM: 'HM',
  NF: 'NF',
  IS: 'IS',
  AX: 'AX',
  KY: 'KY',
  CK: 'CK',
  FK: 'FK',
  FO: 'FO',
  MP: 'MP',
  MH: 'MH',
  PN: 'PN',
  RE: 'RE',
  SB: 'SB',
  VI: 'VI',
  VG: 'VG',
  IL: 'IL',
  IT: 'IT',
  JM: 'JM',
  JP: 'JP',
  JE: 'JE',
  JO: 'JO',
  QA: 'QA',
  KZ: 'KZ',
  KE: 'KE',
  KG: 'KG',
  KI: 'KI',
  KW: 'KW',
  SY: 'SY',
  KR: 'KR',
  CD: 'CD',
  KP: 'KP',
  LA: 'LA',
  UM: 'UM',
  TC: 'TC',
  LS: 'LS',
  LV: 'LV',
  LB: 'LB',
  LR: 'LR',
  LY: 'LY',
  LI: 'LI',
  LT: 'LT',
  AE: 'AE',
  NL: 'NL',
  LU: 'LU',
  MO: 'MO',
  MK: 'MK',
  MG: 'MG',
  MY: 'MY',
  MW: 'MW',
  MV: 'MV',
  ML: 'ML',
  MT: 'MT',
  MA: 'MA',
  MQ: 'MQ',
  MR: 'MR',
  MU: 'MU',
  YT: 'YT',
  MX: 'MX',
  FM: 'FM',
  MD: 'MD',
  MC: 'MC',
  MN: 'MN',
  ME: 'ME',
  MS: 'MS',
  MZ: 'MZ',
  NA: 'NA',
  NR: 'NR',
  NP: 'NP',
  NI: 'NI',
  NE: 'NE',
  NG: 'NG',
  NU: 'NU',
  NO: 'NO',
  NC: 'NC',
  NZ: 'NZ',
  OM: 'OM',
  PK: 'PK',
  PW: 'PW',
  PS: 'PS',
  PA: 'PA',
  PG: 'PG',
  PY: 'PY',
  PE: 'PE',
  PF: 'PF',
  PL: 'PL',
  PT: 'PT',
  PR: 'PR',
  GB: 'GB',
  CF: 'CF',
  CZ: 'CZ',
  GE: 'GE',
  MM: 'MM',
  TD: 'TD',
  CG: 'CG',
  ST: 'ST',
  TL: 'TL',
  DO: 'DO',
  TZ: 'TZ',
  RW: 'RW',
  RO: 'RO',
  RU: 'RU',
  EH: 'EH',
  AS: 'AS',
  WS: 'WS',
  BL: 'BL',
  KN: 'KN',
  SM: 'SM',
  MF: 'MF',
  PM: 'PM',
  VC: 'VC',
  SH: 'SH',
  LC: 'LC',
  SN: 'SN',
  RS: 'RS',
  SC: 'SC',
  SL: 'SL',
  SG: 'SG',
  SX: 'SX',
  SO: 'SO',
  LK: 'LK',
  ZA: 'ZA',
  SD: 'SD',
  SS: 'SS',
  SE: 'SE',
  CH: 'CH',
  SR: 'SR',
  SJ: 'SJ',
  SZ: 'SZ',
  TH: 'TH',
  TW: 'TW',
  TJ: 'TJ',
  IO: 'IO',
  CC: 'CC',
  TF: 'TF',
  TG: 'TG',
  TK: 'TK',
  TO: 'TO',
  TT: 'TT',
  TN: 'TN',
  TM: 'TM',
  TR: 'TR',
  TV: 'TV',
  UA: 'UA',
  UG: 'UG',
  KM: 'KM',
  UY: 'UY',
  UZ: 'UZ',
  VU: 'VU',
  VA: 'VA',
  VE: 'VE',
  VN: 'VN',
  WF: 'WF',
  YE: 'YE',
  ZM: 'ZM',
  ZW: 'ZW'
};

export const countriesList = Object.entries(countriesEnum).map(
  ([key, value]) => ({
    key: value,
    name: `COUNTRIES.${key}`
  })
);

export default countriesEnum;
